import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Transparent layout wrapper for /vault/document/$ref and its sub-routes
 * (edit, review). Renders <Outlet /> only so:
 *   - /vault/document/$ref       → vault_.document.$ref.index.tsx (DocumentDetail)
 *   - /vault/document/$ref/edit  → vault_.document.$ref.edit.tsx  (EditorPage)
 *   - /vault/document/$ref/review→ vault_.document.$ref.review.tsx (ReviewPage)
 *
 * Without this transparent layout the child routes (edit, review) can't
 * render because TanStack Router needs an <Outlet /> in the parent to
 * slot them in.
 */
export const Route = createFileRoute('/vault_/document/$ref')({
  component: () => <Outlet />,
});
